import { ContactForm } from "components/Contact/ContactForm";
import { FindMe } from "components/Index/FindMe";
import { NextPage } from "next";
import { HomeSeo } from "components/SEO";

const Contact: NextPage = () => {
    return (
        <>
            <HomeSeo />
            <ContactForm />
            <FindMe />
        </>
    );
};

export default Contact;
